import {IMenuItem} from "@/lib/types/common/IMenuItem";
import {useMemo} from "react";
import {useAppSelector} from "@/lib/hooks";
import {Icon} from "@/app/components/common/Icon";
import {useOpenDialog} from "@/lib/dialog-orchestrator/react";
import {DialogsEnum} from "@/lib/enums/DialogsEnum";
import {AuthTypesEnum} from "@/lib/enums/AuthTypesEnum";

interface IConfig {
    onClickCallback?: () => void;
}

export const useTopMenu = (val?: IConfig) => {
    const isAuthorized = useAppSelector(state => !!state.auth.userId);
    const openDialog = useOpenDialog();

    const topMenuItems = useMemo(() => {
        const TOP_MENU_ITEMS: IMenuItem[] = [
            {
                icon: <Icon name={'home'} />,
                title: 'TopMenuItems.home',
                href: '/',
                isSoon: false,
                onClick() {
                    val?.onClickCallback?.();
                }
            },
            {
                icon: <Icon name={'favouriteStroke'} />,
                title: 'TopMenuItems.favourites',
                href: isAuthorized ? '/casino/favourites' : '#',
                isSoon: false,
                onClick() {
                    if (!isAuthorized) {
                        openDialog(DialogsEnum.AUTH, {props: {tab: AuthTypesEnum.REGISTER}});
                        return;
                    }
                    val?.onClickCallback?.();
                }
            },
            {
                icon: <Icon name={'bonuses'} />,
                title: 'TopMenuItems.bonuses',
                href: isAuthorized ? '/casino/bonuses' : '#',
                isSoon: false,
                onClick() {
                    if (!isAuthorized) {
                        openDialog(DialogsEnum.AUTH, {props: {tab: AuthTypesEnum.REGISTER}});
                        return;
                    }
                    val?.onClickCallback?.();
                }
            },
            {
                icon: <Icon name={'latestReleases'} />,
                title: 'TopMenuItems.latestReleases',
                href: '/casino/categories/latest-releases',
                isSoon: false,
                onClick() {
                    val?.onClickCallback?.();
                }
            },
            {
                icon: <Icon name={'challenges'} />,
                title: 'TopMenuItems.challenges',
                href: '#',
                isSoon: true,
                onClick() {
                    val?.onClickCallback?.();
                }
            },
            {
                icon: <Icon name={'trophy'} />,
                title: 'TopMenuItems.tournaments',
                href: '#',
                isSoon: true,
                onClick() {
                    val?.onClickCallback?.();
                }
            },
        ]

        return TOP_MENU_ITEMS;
    }, [isAuthorized, val, openDialog])

    return {topMenuItems}
}
